import Entities from 'STORE';

// Needs Bff implementation
async function unblockUser() {
  try {
    const response = { blockedByMe: false };

    if (!response && !response.blockedByMe) {
      return null;
    }

    return response.blockedByMe;
  } catch (error) {
    console.error(error);
  }

  return null;
}

export default async (userId) => {
  const user = Entities.usersStore.getUserById(userId.toString());

  if (!user) {
    return;
  }

  user.setLoadingBlockedByMe(true);

  const blockedByMe = await unblockUser(user.id);

  if (!blockedByMe) {
    return;
  }

  if (parseInt(blockedByMe.ts, 10) > parseInt(user.blockedByMe.ts, 10)) {
    user.setBlockedByMe(blockedByMe);
  }

  user.setLoadingBlockedByMe(false);
};
